// Promotional placement controls. Product URLs and fulfillment remain available.
export const PROMOTE_STYLE_CLUB = false;
export const PROMOTE_DRAPE_KIT = false;
